/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Select_Guide_PromptInputs */



/**
* | output |
* | --- |
* | "Please select a KNP guide to view terms." |
*
* @param {Knp_Lookup_Select_Guide_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_select_guide_prompt = /** @type {((inputs?: Knp_Lookup_Select_Guide_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Select_Guide_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un guide KNP pour afficher les termes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie einen KNP-Guide aus, um die Bedingungen anzuzeigen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezionare una guida KNP per visualizzare i termini.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите гида КНП, чтобы просмотреть условия.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una guía KNP para ver los términos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择一位克鲁格国家公园导游查看条款。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("条件を表示するには、KNP ガイドを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नियम और शर्तें देखने के लिए कृपया केएनपी गाइड का चयन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um guia do KNP para visualizar os termos.")
	return /** @type {LocalizedString} */ ("Please select a KNP guide to view terms.")
});